import {pageInfo, exportData,details} from './../api';
import {supplierType, plant, weighBusinessType} from '../../../../api'
import {Message} from 'element-ui';

const weigh = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportObj: [],
    detailsObj: null,
    businessTypeObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },

    DEAILS(state, data) {
      state.detailsObj = data;
    },

    WEIGH_BUSINESS_TYPE(state, data) {
      state.businessTypeObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async details({commit}, obj) {
      let resp = await details(obj);
      commit('DEAILS', resp);
    },

    async weighBusinessType({commit}, obj) {
      let resp = await weighBusinessType(obj);
      commit('WEIGH_BUSINESS_TYPE', resp);
    },
  }
}
export default weigh



// WEBPACK FOOTER //
// ./src/page/bd/weigh/store/weigh.store.js